import { table } from './_table';

export const tasks = {
  state: {
    campaign_id: null
  },
  mutations: {
    campaign_id(state, id) {
      state.campaign_id = id;
    }
  },
  namespaced: true,
  modules: {
    table
  }
};
